/* Challenge page (sections/challenge-page.liquid): the video player (YouTube with Clixo's own controls) and Share. */
(function () {
  var root = document.querySelector('[data-cxp]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  /* ---------- Prev / next ----------
     Default: step through every challenge. Came from a pack filter (?pack=): step through that pack's challenges,
     and keep ?pack= on those links and on the "More with" cards so the pack context carries on. */
  (function () {
    var pack = new URLSearchParams(location.search).get('pack');
    var all = root.querySelectorAll('[data-cxp-pn="all"]');
    var inPack = root.querySelectorAll('[data-cxp-pn="pack"]');
    var addPack = function (a) { var u = new URL(a.href, location.href); u.searchParams.set('pack', pack); a.href = u.pathname + u.search; };
    var back = root.querySelector('[data-cxp-back]');
    if (pack && back) back.href = back.getAttribute('href') + '?pack=' + encodeURIComponent(pack);
    if (pack && inPack.length) {
      all.forEach(function (a) { a.hidden = true; });
      inPack.forEach(function (a) { a.hidden = false; addPack(a); });
      root.querySelectorAll('[data-cxp-pack-link]').forEach(addPack);
    }
  })();

  /* ---------- Player ----------
     YouTube plays underneath with its controls off and clicks blocked, so none of its UI shows.
     Our poster covers it until it is actually playing, and again when paused or ended
     (that hides YouTube's start title, pause overlay and end-screen suggestions). */
  var box = root.querySelector('[data-cxp-video]');
  var id = box && box.dataset.videoId;
  if (box && id) {
    var mount = box.querySelector('[data-cxp-mount]');
    var bar = box.querySelector('[data-cxp-bar]');
    var toggleBtn = box.querySelector('[data-cxp-toggle]');
    var seek = box.querySelector('[data-cxp-seek]');
    var muteBtn = box.querySelector('[data-cxp-mute]');
    var fsBtn = box.querySelector('[data-cxp-fs]');
    var player = null, ready = false, wantPlay = false, ticker = null, idleTimer = null, revealTimer = null, seeking = false;

    function setState(s) {
      box.classList.toggle('is-playing', s === 'playing');
      box.classList.toggle('is-paused', s !== 'playing');
      /* paused mid-video: keep the paused frame on screen instead of the poster.
         Stays on through resume so the poster never flashes back in; cleared at the end. */
      if (s === 'held') box.classList.add('is-held');
      else if (s === 'ended') box.classList.remove('is-held');
      toggleBtn.setAttribute('aria-label', s === 'playing' ? 'Pause' : 'Play');
    }
    function loadApi(cb) {
      if (window.YT && window.YT.Player) return cb();
      var prev = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = function () { if (prev) prev(); cb(); };
      if (!document.querySelector('script[src*="youtube.com/iframe_api"]')) {
        var s = document.createElement('script');
        s.src = 'https://www.youtube.com/iframe_api';
        document.head.appendChild(s);
      }
    }
    function tick() {
      if (!player || !ready || seeking) return;
      var d = player.getDuration() || 0, t = player.getCurrentTime() || 0;
      var p = d ? (t / d) * 100 : 0;
      seek.value = Math.round(p * 10);
      seek.style.setProperty('--p', p + '%');
    }
    var nativeMode = false, startAt = 0;
    function create() {
      var el = document.createElement('div');
      mount.appendChild(el);
      player = new YT.Player(el, {
        host: 'https://www.youtube-nocookie.com',
        videoId: id,
        playerVars: { autoplay: 1, controls: 0, disablekb: 1, fs: 0, rel: 0, modestbranding: 1, iv_load_policy: 3, playsinline: nativeMode ? 0 : 1, cc_load_policy: 0, cc_lang_pref: 'en', hl: 'en', start: Math.floor(startAt) },
        events: {
          onReady: function (e) {
            ready = true;
            var f = e.target.getIframe();
            f.setAttribute('title', (box.dataset.title || 'Challenge') + ' tutorial');
            f.setAttribute('tabindex', '-1');
            /* no captions: YouTube's auto-generated ones (e.g. "[Music]" in another language) otherwise show, mostly in iPhone full screen */
            try { e.target.unloadModule('captions'); e.target.unloadModule('cc'); e.target.setOption('captions', 'track', {}); } catch (err) {}
            if (wantPlay) e.target.playVideo();
          },
          onStateChange: function (e) {
            var S = YT.PlayerState;
            if (e.data === S.PLAYING) {
              box.classList.remove('is-loading');
              bar.hidden = false;
              /* keep the cover up a beat so YouTube's start/play flash never shows */
              clearTimeout(revealTimer);
              if (box.classList.contains('is-held')) setState('playing');
              else revealTimer = setTimeout(function () { if (player.getPlayerState() === YT.PlayerState.PLAYING) setState('playing'); }, 700);
              if (!ticker) ticker = setInterval(tick, 250);
              poke();
            } else if (e.data === S.PAUSED || e.data === S.BUFFERING && !box.classList.contains('is-playing')) {
              clearTimeout(revealTimer);
              if (e.data === S.PAUSED) setState(player.getCurrentTime() > 0 ? 'held' : 'paused'); /* keep the paused frame on screen */
            } else if (e.data === S.ENDED) {
              setState('ended');
              seek.value = 1000; seek.style.setProperty('--p', '100%');
            }
          }
        }
      });
    }
    function play() {
      wantPlay = true;
      if (player && ready) { player.playVideo(); return; }
      if (player) return;
      box.classList.add('is-loading');
      bar.hidden = false;
      setState('paused');
      loadApi(create);
    }
    function pause() { if (player && ready) player.pauseVideo(); }
    function toggle() { box.classList.contains('is-playing') ? pause() : play(); }
    /* phones: the control bar (under the video) shows from the start; its play button starts the video */
    if (window.matchMedia('(max-width: 699px)').matches) { bar.hidden = false; setState('paused'); }

    /* hide the controls after a moment of no movement while playing */
    function poke() {
      box.classList.remove('is-idle');
      clearTimeout(idleTimer);
      idleTimer = setTimeout(function () { if (box.classList.contains('is-playing')) box.classList.add('is-idle'); }, 2500);
    }

    root.querySelectorAll('[data-cxp-play]').forEach(function (b) { b.addEventListener('click', play); });
    toggleBtn.addEventListener('click', toggle);
    box.addEventListener('click', function (e) { if (!e.target.closest('button, input, [data-cxp-bar]')) toggle(); });
    box.addEventListener('mousemove', poke);
    box.addEventListener('touchstart', poke, { passive: true });
    box.addEventListener('focusin', poke);

    seek.addEventListener('input', function () { seeking = true; seek.style.setProperty('--p', (seek.value / 10) + '%'); });
    seek.addEventListener('change', function () {
      seeking = false;
      if (!player || !ready) return;
      player.seekTo((seek.value / 1000) * (player.getDuration() || 0), true);
      if (!box.classList.contains('is-playing')) player.playVideo();
    });

    muteBtn.addEventListener('click', function () {
      if (!player || !ready) return;
      if (player.isMuted()) { player.unMute(); box.classList.remove('is-muted'); muteBtn.setAttribute('aria-label', 'Mute'); }
      else { player.mute(); box.classList.add('is-muted'); muteBtn.setAttribute('aria-label', 'Unmute'); }
    });

    /* Full screen: the Fullscreen API where it exists (desktop, Android, iPad). iPhone Safari has none for page
       elements, so there the player fills the screen with CSS instead (rotate the phone for a bigger picture). */
    var fsEl = box.requestFullscreen ? 'requestFullscreen' : (box.webkitRequestFullscreen ? 'webkitRequestFullscreen' : null);
    function fakeFs(on) {
      box.classList.toggle('is-fakefs', on);
      document.documentElement.classList.toggle('cxp-noscroll', on);
      fsBtn.setAttribute('aria-label', on ? 'Exit full screen' : 'Full screen');
    }
    fsBtn.addEventListener('click', function () {
      if (box.classList.contains('is-fakefs')) return fakeFs(false);
      var on = document.fullscreenElement || document.webkitFullscreenElement;
      if (on) return (document.exitFullscreen || document.webkitExitFullscreen).call(document);
      if (fsEl) {
        var r = box[fsEl]();
        if (r && r.catch) r.catch(function () { fakeFs(true); });
      } else if (/iPhone|iPod/.test(navigator.userAgent)) {
        goNative();
      } else {
        fakeFs(true);
      }
    });
    /* iPhone: pages can't put an element full screen, only iOS's own video player can. Rebuild the YouTube player
       with inline playback off, from the same moment: iOS then plays it in its native full-screen player. */
    function goNative() {
      startAt = player && ready ? (player.getCurrentTime() || 0) : 0;
      if (player && player.destroy) { try { player.destroy(); } catch (e) {} }
      player = null; ready = false;
      mount.innerHTML = '';
      nativeMode = true;
      wantPlay = true;
      box.classList.add('is-loading');
      loadApi(create);
    }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && box.classList.contains('is-fakefs')) fakeFs(false); });

    box.addEventListener('keydown', function (e) {
      if (e.target === seek) return;
      if (e.key === ' ' || e.key === 'k') { if (player) { e.preventDefault(); toggle(); } }
    });
  }

  /* ---------- Share ---------- */
  var share = root.querySelector('[data-cxp-share]');
  if (share) share.addEventListener('click', function () {
    var data = { title: share.dataset.title, url: location.href.split('?')[0] };
    if (navigator.share) { navigator.share(data).catch(function () {}); return; }
    if (navigator.clipboard) {
      navigator.clipboard.writeText(data.url).then(function () {
        var label = share.querySelector('[data-cxp-share-label]');
        label.textContent = 'Link copied';
        setTimeout(function () { label.textContent = ''; }, 2000);
      });
    }
  });
})();

/* Touch screens: the outer "packs fit together" quads swap places as the note scrolls up the screen and swap
   back as it scrolls down, following the scroll (--mixp: 0 with the note at 75% of the screen height, 1 at 40%). */
(function () {
  if (!window.matchMedia || !window.matchMedia('(hover: none)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var notes = Array.prototype.filter.call(document.querySelectorAll('.cx-mix'), function (n) { return n.querySelector('.cx-mix__icon'); });
  if (!notes.length) return;
  var from = 0.75, to = 0.40, ticking = false;
  function update() {
    ticking = false;
    var vh = window.innerHeight;
    notes.forEach(function (n) {
      var icon = n.querySelector('.cx-mix__icon').getBoundingClientRect();
      var y = (icon.top + icon.height / 2) / vh;
      var p = (from - y) / (from - to);
      n.style.setProperty('--mixp', Math.max(0, Math.min(1, p)).toFixed(4));
    });
  }
  notes.forEach(function (n) { n.setAttribute('data-cx-scrub', ''); });
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
  window.addEventListener('resize', update);
  update();
})();
